<div class="flex layout-column full-height">
  <!--Search Box-->
  <div class="layout-row layout-align-start-center padding-top-10 padding-left-10 padding-right-10 padding-bottom-5">
    <app-bringoz-search-input class="flex"
                              [query]="queryString"
                              (queryChangeEvent)="onQueryChange($event)">
    </app-bringoz-search-input>
  </div>

  <hr class="main-divider">

  <!--List-->
  <div class="flex layout-column overflow-hidden relative">
    <cdk-virtual-scroll-viewport
      *ngIf="optionsToDisplay.length > 0"
      class="flex full-height viewport"
      [itemSize]="30"
      (scrolledIndexChange)="getNextBatch()">

      <div class="layout-row layout-align-start-center option-row" *cdkVirtualFor="let option of optionsToDisplay">
        <app-bringoz-checkbox [isChecked]="selectedAgentIdsMap[option.id]"
                              [isDisabled]="option.alreadyInProject"
                              (clickEvent)="onSelectAgent(option.id)">
        </app-bringoz-checkbox>

        <div class="flex margin-left-10 layout-column overflow-hidden">
          <span class="br-body-2 font-weight-400 text-ellipsis"
                [ngClass]="{'gray-102': option.alreadyInProject}">
            {{ option.fullName }}
          </span>
          <span *ngIf="option.alreadyInProject" class="br-caption-1 gray-102" translate>Already in project</span>
        </div>

        <div class="layout-row layout-align-start-center flex-30">
          <bringoz-icon iconName="tag-outline" class="margin-right-5" fill="#7E7E7E"></bringoz-icon>
          <app-bringoz-tags *ngIf="option.tags?.length"
                            class="flex"
                            [tags]="option.tags"
                            [maxTags]="1">
          </app-bringoz-tags>
          <span *ngIf="!option.tags?.length">---</span>
        </div>

        <div class="layout-row layout-align-start-center flex-30">
          <bringoz-icon iconName="branch" class="margin-right-5" fill="#7E7E7E"></bringoz-icon>
          <branches-indicator *ngIf="option.branchReferences?.length"
                              class="flex"
                              [branches]="option.branchReferences">

          </branches-indicator>
          <span *ngIf="!option.branchReferences?.length">---</span>
        </div>

      </div>

    </cdk-virtual-scroll-viewport>

    <div *ngIf="!isLoading && optionsToDisplay.length === 0" class="br-body-2 font-weight-400 gray-102 text-center margin-top-20">
      {{ 'No drivers found' | translate }}
    </div>

  </div>

  <app-bringoz-linear-progress *ngIf="!!isLoading"></app-bringoz-linear-progress>
</div>
